export enum OrderType {
  Order = "0",
  Quote = "1"
}

export enum OrderTypeString {
  Order = "SalesOrder",
  Quote = "Quote"
}
